import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import footer from './../../images/footer.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
   
  },
  main: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
  },
}));

function Footer() {
  const classes = useStyles();
  return (
   <div className={classes.root}>
      <CssBaseline />  
      <footer className="footer-ss">
        <Container >
        <Grid container className="my-2">
                <Grid item xs={12} sm={6} md={6}  className="px-3" >
                    <img src={footer} alt={"SuperIntendencia de Salud"} className="imagen-footer"/>
                </Grid>
                
            </Grid>
        </Container>
      </footer>
    </div> 
/*     <>
    <footer className="footer-ss">
        <Container className=" ">
            <Grid container className="my-2">
                <Grid item xs={12} sm={6} md={6}  className="px-3" >
                    <img src={footer} alt={"SuperIntendencia de Salud"} className="imagen-footer"/>
                </Grid>
                
            </Grid>
            <Copyright />
        </Container>
    </footer>

   
   
</> 
 */    
  );
}

export default Footer;